// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PressSidebar__inner___2It7G{position:-webkit-sticky;position:sticky;top:96px}.PressSidebar__logoContainer___3aaY1{display:flex;height:330px;margin-bottom:80px}.PressSidebar__logo___gZA2p{align-self:flex-end;max-width:240px}.PressSidebar__date___3R600{color:#c0beb8;font-weight:700;text-transform:uppercase}.PressSidebar__title___3ykRT{color:inherit;font-weight:500;font-size:40px;line-height:56px;margin-top:8px;font-weight:200}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"inner": "PressSidebar__inner___2It7G",
	"logoContainer": "PressSidebar__logoContainer___3aaY1",
	"logo": "PressSidebar__logo___gZA2p",
	"date": "PressSidebar__date___3R600",
	"title": "PressSidebar__title___3ykRT"
};
module.exports = ___CSS_LOADER_EXPORT___;
